export default "__VITE_ASSET__DD5I67yi__"